import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { IssueEditor } from '@/components/issues/IssueEditor'
import { issueQuery } from '@/lib/issue-queries'
import { reportQuery, sessionQuery } from '@/lib/queries'

/**
 * The report editor for one issue. The loader prefetches the issue shell (headers + counts) and
 * the report (delivery settings for the send dialog, sections for context); the header on screen
 * loads its own items once the editor mounts — never the whole issue.
 */
export const Route = createFileRoute(
  '/app/accounts/$accountId_/reports/$reportId_/issues/$issueId',
)({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(reportQuery(params.reportId)),
      context.queryClient.ensureQueryData(issueQuery(params.issueId)),
      context.queryClient.ensureQueryData(sessionQuery),
    ])
  },
  component: IssueEditorPage,
})

function IssueEditorPage() {
  const { accountId, reportId, issueId } = Route.useParams()
  const { data: report } = useSuspenseQuery(reportQuery(reportId))
  const { data: session } = useSuspenseQuery(sessionQuery)
  return (
    <IssueEditor
      accountId={accountId}
      report={report}
      issueId={issueId}
      userEmail={session.user?.email ?? null}
    />
  )
}
